import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();

export const getSongsList = (eventId = null) => {
  const queryParam = eventId ? `?eventId=${eventId}` : '';
  return api.get(url.GET_VIEW_SONGS_LIST + queryParam);
};

export const getSongsLibrary = () => api.get(url.GET_SONGS_LIBRARY);

export const updateSong = (id, data) => api.update(url.UPDATE_SONG(id), data);

export const deleteSong = (id) => api.delete(url.DELETE_SONG(id));

